import { AdminPageContent } from "@/components/admin";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";
import { TopicsTable } from "./components/TopicsTable";

const AdminTopics = () => {
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Topics");

    useMountEffect(() => {
        setBreadcrumbs([{ label: "Admin", path: "home" }, { label: "Topics" }]);
    });

    return (
        <AdminPageContent>
            <TopicsTable />
        </AdminPageContent>
    );
};

export default AdminTopics;
